<template>
  <el-row>
    <!-- <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="今日记录"
                   name="today"></el-tab-pane>
      <el-tab-pane label="历史记录"
                   name="history"></el-tab-pane>
    </el-tabs> -->
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="员工卡号:"
                      prop="person_no">
          <el-input v-model.trim="searchForm.person_no"
                    placeholder="员工卡号"></el-input>
        </el-form-item>
        <el-form-item label="员工姓名:"
                      prop="person_name">
          <el-input v-model.trim="searchForm.person_name"
                    placeholder="员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系方式:"
                      prop="person_ctx">
          <el-input v-model.trim="searchForm.person_ctx"
                    placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="房间:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间"></el-input>
        </el-form-item>
        <el-form-item label="设备名称:"
                      prop="lock_name">
          <el-input v-model.trim="searchForm.lock_name"
                    placeholder="设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="开门介质:"
                      prop="open_med">
          <el-select v-model="searchForm.open_med"
                     placeholder="开门结果">
            <el-option label="全部"
                       value=""></el-option>
            <el-option v-for="item in medList"
                       :key="item.value"
                       :label="item.name"
                       :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item label="开门结果:"
                      prop="open_result">
          <el-select v-model="searchForm.open_result"
                     placeholder="开门结果">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="正常"
                       value="1"></el-option>
            <el-option label="非法"
                       value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实时/历史:"
                      prop="history">
          <el-select v-model="searchForm.history"
                     placeholder="实时/历史">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="实时"
                       value="0"></el-option>
            <el-option label="历史"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围:">
          <el-date-picker v-model="searchForm.time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/person_lock/export'"
                 type="primary"
                 @click="handleExport">导 出</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :row-class-name="tableRowClassName"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import utils from '@/common/utils'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      activeName: 'today',
      medList: [],
      areaList: [],
      tmpArr: [],
      searchForm: {
        person_name: '',
        person_no: '',
        person_ctx: '',
        room_name: '',
        lock_name: '',
        area_id: '',
        open_med: '',
        open_result: '',
        history: '',
        time: []
      },
      tableTitle: [
        {
          prop: 'time_stamp',
          name: '时间',
          width: '160'
        },
        {
          prop: 'history',
          name: '实时/历史',
          width: '100'
        },
        {
          prop: 'room_name',
          name: '房间名称',
          width: '100'
        },
        {
          prop: 'med_value',
          name: '介质内容',
          width: '100'
        },
        {
          prop: 'person_no',
          name: '员工卡号',
          width: '80'
        },
        {
          prop: 'person_name',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'person_ctx',
          name: '联系方式',
          width: '120'
        },
        {
          prop: 'open_med',
          name: '开锁方式',
          width: '120'
        },
        {
          prop: 'lock_model',
          name: '设备型号',
          width: '100'
        },
        {
          prop: 'lock_sn',
          name: '设备编号',
          width: '100'
        },
        {
          prop: 'lock_name',
          name: '设备名称',
          width: '100'
        },
        {
          prop: 'lock_electricity',
          name: '电量',
          width: '60'
        },
        {
          prop: 'dev_type',
          name: '设备类型',
          width: '80'
        },
        {
          prop: 'area_names',
          name: '所属区域',
          width: '200'
        },
        {
          prop: 'open_type',
          name: '开门方式',
          width: '80'
        },
        {
          prop: 'open_resultTxt',
          name: '开门结果',
          width: '80'
        },
        {
          prop: 'stat_lock',
          name: '设备情况',
          width: '80'
        },
        {
          prop: 'stat_person',
          name: '人员情况',
          width: '80'
        },
        {
          prop: 'stat_permission',
          name: '权限情况',
          width: '80'
        },
        {
          prop: 'stat_tslot',
          name: '时间组情况',
          width: '100'
        },
        {
          prop: 'stat_holiday',
          name: '假日组情况',
          width: '120'
        },
        {
          prop: 'back_person',
          name: '应急联系人',
          width: '110'
        },
        {
          prop: 'back_ctx',
          name: '应急联系方式',
          width: '120'
        },
        {
          prop: 'exp_date',
          name: '人员有效期',
          width: '120'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      }
    }
  },
  created() {
    this.getList()
    this.getItemList()
    this.getAreaTree()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const { searchForm } = this
      let datas = {
        person_name: searchForm.person_name,
        person_no: searchForm.person_no,
        person_ctx: searchForm.person_ctx,
        room_name: searchForm.room_name,
        lock_name: searchForm.lock_name,
        area_id: searchForm.area_id,
        open_med: searchForm.open_med,
        open_result: searchForm.open_result,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : '',
        history: searchForm.history
      }
      fetch
        .getPersonRecordList({
          // type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.open_resultTxt = item.open_result === '1' ? '正常' : '非法'
                item.stat_lock = item.stat_lock === '1' ? '正常' : '未注册'
                item.history = item.history === '0' ? '实时' : '历史'
                item.stat_person =
                  item.stat_person === '1'
                    ? '正常'
                    : item.stat_person === '2'
                    ? '锁定'
                    : item.stat_person === '3'
                    ? '注销'
                    : item.stat_person === '4'
                    ? '未注册'
                    : '未知'
                item.stat_permission =
                  item.stat_permission === '1'
                    ? '正常'
                    : item.stat_person === '2'
                    ? '未授权'
                    : '未知'
                item.stat_tslot =
                  item.stat_tslot === '1' ? '正常' : item.stat_person === '2' ? '异常' : '未知'
                item.stat_holiday =
                  item.stat_holiday === '1' ? '正常' : item.stat_person === '2' ? '异常' : '未知'
                item.open_med =
                  item.auth_mode === '1'
                    ? '员工卡'
                    : item.auth_mode === '2'
                    ? '房卡'
                    : item.auth_mode === '3'
                    ? '身份证'
                    : item.auth_mode === '4'
                    ? '指纹'
                    : item.open_med
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取介质类型
    getItemList() {
      fetch.getItemList({ type_code: 'open_med' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.medList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 导出
    handleExport() {
      const { searchForm } = this
      let datas = {
        person_name: searchForm.person_name,
        person_no: searchForm.person_no,
        person_ctx: searchForm.person_ctx,
        room_name: searchForm.room_name,
        lock_name: searchForm.lock_name,
        area_id: searchForm.area_id,
        open_med: searchForm.open_med,
        open_result: searchForm.open_result,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : ''
      }
      fetch
        .exportPersonRecord(
          {
            ...datas
          },
          { responseType: 'blob' }
        )
        .then((data) => {
          var blob = new Blob([data.res])
          let date = utils.format(new Date().getTime(), 'yyyy-MM-dd')
          let filename = '开设备记录-' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        })
    },
    tableRowClassName({ row }) {
      if (row.open_result === '1') {
        return 'succes-row'
      } else if (row.open_result === '2') {
        return 'error-row'
      }
      return 'error-row'
    }
  }
}
</script>

<style lang="less">
.el-table .succes-row {
  background: rgba(103, 194, 58, 0.2);
}
.el-table .error-row {
  background: rgba(245, 108, 108, 0.2);
}
</style>
